export const MASKED_COST = '****';
export const NULL_DATE = '00/00/00';
export const NO_VEHICLE_SELECTED = '-1';
export const LONG_LIT_FRENCH = 'B';
export const SPG_ALL_ID = 'ALL';
